import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { colspan: "2" }

import SogCard from "@/shared/ui/SogCard.vue";
import OrderItem from "@/shared/model/orderItem";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";

interface Props {
  item:OrderItem
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'DeliveryCardItemComponent',
  props: {
    item: { default: undefined }
  },
  setup(__props: any) {


const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, { class: "sog-card-without-title" }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_1, [
                _createVNode(SogDataLabel, {
                  value: props.item.description
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[0] || (_cache[0] = _createElementVNode("td", null, "Anzahl", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.item.count
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[1] || (_cache[1] = _createElementVNode("td", null, " Prämie ", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: props.item.productGrossPrice,
                  "value-type": _unref(SogDataLabelValueType).Money
                }, null, 8, ["value", "value-type"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})